export const GET_QUOTES = "GET_QUOTES"
export const GET_QUOTES_SUCCESS = "GET_QUOTES_SUCCESS"
export const GET_QUOTES_FAIL = "GET_QUOTES_FAIL"

export const GET_QUOTE_DETAIL = "GET_QUOTE_DETAIL"
export const GET_QUOTE_DETAIL_SUCCESS = "GET_QUOTE_DETAIL_SUCCESS"
export const GET_QUOTE_DETAIL_FAIL = "GET_QUOTE_DETAIL_FAIL"

export const ADD_NEW_QUOTE = "ADD_NEW_QUOTE"
export const ADD_NEW_QUOTE_SUCCESS = "ADD_NEW_QUOTE_SUCCESS"
export const ADD_NEW_QUOTE_FAIL = "ADD_NEW_QUOTE_FAIL"

export const UPDATE_QUOTE = "UPDATE_QUOTE"
export const UPDATE_QUOTE_SUCCESS = "UPDATE_QUOTE_SUCCESS"
export const UPDATE_QUOTE_FAIL = "UPDATE_QUOTE_FAIL"

export const DELETE_QUOTE = "DELETE_QUOTE"
export const DELETE_QUOTE_SUCCESS = "DELETE_QUOTE_SUCCESS"
export const DELETE_QUOTE_FAIL = "DELETE_QUOTE_FAIL"

export const CONVERT_QUOTE_TO_INVOICE = "CONVERT_QUOTE_TO_INVOICE"
export const CONVERT_QUOTE_TO_INVOICE_SUCCESS = "CONVERT_QUOTE_TO_INVOICE_SUCCESS"
export const CONVERT_QUOTE_TO_INVOICE_FAIL = "CONVERT_QUOTE_TO_INVOICE_FAIL"
